import React, {useContext} from 'react'
import {ToggleContext} from '@/builder/blocks/toggle'
import PropTypes from 'prop-types'

export function ToggleContent({children, attributes}) {
    const {isOpen} = useContext(ToggleContext)
    return isOpen && <div {...attributes}>{children}</div>
}

ToggleContent.propTypes = {
    children: PropTypes.node,
    attributes: PropTypes.object
}
export const ToggleContentDefinition = {
    component: ToggleContent,
    name: 'ToggleContent',
    canHaveChildren: true,
    hideFromInsertMenu: true,
    noWrap: true,
    image: 'https://unpkg.com/css.gg@2.0.0/icons/svg/toggle-off.svg'
}
